<dx-data-grid
  [dataSource]="productDataSource"
  [showBorders]="true"
  [columnAutoWidth]="true"
  (onCellPrepared)="onCellPrepared($event)"
>
  <dxi-column dataField="product_code" dataType="number" width="100px"></dxi-column>
  <dxi-column dataField="product_name" dataType="string"></dxi-column>
  <dxo-paging [pageSize]="5"></dxo-paging>
</dx-data-grid>
